import { EditOutlined, FileExcelOutlined, MailOutlined } from "@ant-design/icons";
import { Space, Button, Select, Tag, Segmented, message, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, PageHeaderItem, } from "../../../Components/Items";
import dayjs from "dayjs";
import AgregarRegistro from "./AgregarRegistro/AgregarRegistro";
import EditarRegistro from "./EditarRegistro/EditarRegistro";
import RegistrarPago from "./RegistrarPago/RegistrarPago";
import round2Decimals from "../../../Components/round2Decimals";
import RegistrarDevolucion from "./RegistrarDevolucion/RegistrarDevolucion";
import * as XLSX from "xlsx";


const { Option } = Select

class Registros extends Component {
    state = {
        todasRegistros: [],
        loading: false,
        todasAnos: [],
        objetoAnos: null,
        modalAgregarRegistro: false,
        modalEditarRegistro: false,
        modalEditarRegistroId: null,
        modalRegistrarPago: false,
        modalRegistrarPagoId: null,
        modalRegistrarDevolucion: false,
        modalRegistrarDevolucionId: null,
        ano: undefined,
        segmented: 1
    }
    componentDidMount() {
        this.consultarRegistros();
    }

    async consultarRegistros() {
        this.setState({ loading: true })

        let ultimoAno

        await axios
            .post(
                "registrosCarrera/datosRegistroElegir",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    if (res.data?.anos?.length !== 0) {
                        ultimoAno = res.data.anos[res.data.anos.length - 1]
                    }
                    this.setState({
                        todasAnos: res.data.anos,
                        ano: ultimoAno,
                        objetoAnos: res.data.anos.map((value) => {
                            return (
                                <Option value={value} key={value}>{value}</Option>
                            )
                        }),
                    });
                }
            });

        await axios
            .post(
                "registrosCarrera/selectTodasRegistros",
                { empresaId: this.props.empresaId, ano: ultimoAno, filtro: this.state.segmented },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasRegistros: res.data.registros.map((value) => {
                            return {
                                ...value,
                                accion: { _id: value._id, estado: value.estado, estadoPago: value.estadoPago, total: value.total, totalPagado: value.totalPagado },
                            };
                        }),
                    });
                }
            });

        this.setState({ loading: false })
    }

    // deshabilitarCarrera(value) {
    //     axios
    //         .post(
    //             "carreras/deshabilitarCarrera",
    //             { carreraId: value, empresaId: this.props.empresaId },
    //             { headers: this.props.headersToken }
    //         )
    //         .then((res) => {
    //             if (res.data.success === 2) {
    //                 message.success("Carrera deshabilitada");
    //             } else {
    //                 message.error("Sucedio un error y no se pudo deshabilitar");
    //             }
    //             this.consultarRegistros();
    //         });
    // }

    // habilitarCarrera(value) {
    //     axios
    //         .post(
    //             "carreras/habilitarCarrera",
    //             { carreraId: value, empresaId: this.props.empresaId },
    //             { headers: this.props.headersToken }
    //         )
    //         .then((res) => {
    //             if (res.data.success === 2) {
    //                 message.success("Carrera habilitada");
    //             } else {
    //                 message.error("Sucedio un error y no se pudo habilitar");
    //             }
    //             this.consultarRegistros();
    //         });
    // }

    agregarCarrera() {
        this.setState({ modalAgregarRegistro: true })
    }

    editarCarrera(value) {
        this.setState({ modalEditarRegistro: true, modalEditarRegistroId: value })
    }
    cerrarModalAgregarRegistro() {
        this.setState({ modalAgregarRegistro: false });
        this.consultarRegistros();
    }
    cerrarModalEditarRegistro() {
        this.setState({ modalEditarRegistro: false, modalEditarRegistroId: null })
        this.consultarRegistros()
    }

    cerrarModalRegistrarPago() {
        this.setState({ modalRegistrarPago: false, modalRegistrarPagoId: null })
        this.consultarRegistros()
    }

    cerrarModalRegistrarDevolucion() {
        this.setState({ modalRegistrarDevolucion: false, modalRegistrarDevolucionId: null })
        this.consultarRegistros()
    }

    onChangeAno(ano) {
        this.setState({ loading: true, ano: ano })
        axios
            .post(
                "registrosCarrera/selectTodasRegistros",
                { empresaId: this.props.empresaId, ano, filtro: this.state.segmented },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        todasRegistros: res.data.registros.map((value) => {
                            return {
                                ...value,
                                accion: { _id: value._id, estado: value.estado, estadoPago: value.estadoPago, total: value.total, totalPagado: value.totalPagado },
                            };
                        }),
                    });
                }
            });
    }

    onChangeSegmented(value) {
        this.setState({ loading: true, segmented: value })
        axios
            .post(
                "registrosCarrera/selectTodasRegistros",
                { empresaId: this.props.empresaId, ano: this.state.ano, filtro: value },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        todasRegistros: res.data.registros.map((value) => {
                            return {
                                ...value,
                                accion: { _id: value._id, estado: value.estado, estadoPago: value.estadoPago, total: value.total, totalPagado: value.totalPagado },
                            };
                        }),
                    });
                }
            });
    }

    calcularEdad(fechaNacimiento) {
        const hoy = dayjs(); // Fecha actual
        const nacimiento = dayjs(fechaNacimiento); // Fecha de nacimiento
        return hoy.diff(nacimiento, 'year'); // Diferencia en años
    }

    registrarPago(value) {
        this.setState({ modalRegistrarPago: true, modalRegistrarPagoId: value })
    }

    registrarDevolucion(value) {
        this.setState({ modalRegistrarDevolucion: true, modalRegistrarDevolucionId: value })
    }

    descargarExcel() {
        let datosDescargar = this.state.todasRegistros.map(valueRegistro => {

            const edad = this.calcularEdad(valueRegistro.fechaNacimiento)
            let categoria = ''
            if (edad >= 50) {
                categoria = "Master 50+"
            } else if (edad >= 40) {
                categoria = "Master 40-49"
            } else {
                categoria = "Libre"
            }

            let pago = ''

            if (valueRegistro.estadoPago === 1) {
                pago = 'Sin pago'
            } else if (valueRegistro.estadoPago === 2) {
                pago = 'Parcialmente pagado'
            } else {
                pago = 'Pagado'
            }

            return {
                "Referencia": valueRegistro.folio,
                "Numero Corredor": valueRegistro.numeroCarrera,
                'Nombre': valueRegistro.nombre,
                'Correo': valueRegistro.correo,
                'Telefono': valueRegistro.telefono,
                'Rama': valueRegistro.rama === 1 ? 'Varonil' : 'Femenil',
                'Categoría': categoria,
                'Equipo': valueRegistro.equipo,
                'Carrera': valueRegistro.carreraNombre,
                'Pago': pago,
                "Total": valueRegistro.total,
                "Total Pagado": valueRegistro.totalPagado
            }
        });

        const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Registros"
        );
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(
            workbook,
            `Registros_${dayjs().format('DD_MM_YYYY')}.xlsx`
        );
    }

    mandarCorreoRegistro(value) {
        this.setState({ loading: true })
        axios
            .post(
                "registrosCarrera/mandarCorreoRegistro",
                { registroId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    message.success("Correo enviado exitosamente");
                } else {
                    message.error("Sucedio un error y no se pudo enviar el correo");
                }
                this.consultarRegistros();
            }).catch(() => {
                this.setState({ loading: false })
                message.error("Error al comunicarse con el servidor");
            });
    }

    
    mandarPagoRegistro(value) {
        this.setState({ loading: true })
        axios
            .post(
                "registrosCarrera/mandarCorreoPago",
                { registroId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    message.success("Correo enviado exitosamente");
                } else {
                    message.error("Sucedio un error y no se pudo enviar el correo");
                }
                this.consultarRegistros();
            }).catch(() => {
                this.setState({ loading: false })
                message.error("Error al comunicarse con el servidor");
            });
    }

    render() {
        const columns = [
            {
                title: "Referencia",
                dataIndex: "folio",
                key: "folio",
                sorter: (a, b) => {
                    if (!a.folio) return 1;
                    if (!b.folio) return -1;
                    const numA = a.folio || 0;
                    const numB = b.folio || 0;
                    return numA - numB;
                },
                buscar: "folio",
            },
            {
                title: "Numero",
                dataIndex: "numeroCarrera",
                key: "numeroCarrera",
                sorter: (a, b) => {
                    if (!a.numeroCarrera) return 1;
                    if (!b.numeroCarrera) return -1;
                    const numA = a.numeroCarrera || 0;
                    const numB = b.numeroCarrera || 0;
                    return numA - numB;
                },
                buscar: "numeroCarrera",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                sorter: (a, b) => {
                    if (a.nombre < b.nombre) {
                        return -1;
                    }
                    if (a.nombre > b.nombre) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "nombre",
            },
            {
                title: "Categoria",
                dataIndex: "fechaNacimiento",
                key: "fechaNacimiento",
                sorter: (a, b) => {
                    if (a.fechaNacimiento < b.fechaNacimiento) {
                        return -1;
                    }
                    if (a.fechaNacimiento > b.fechaNacimiento) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => {
                    const edad = this.calcularEdad(value)
                    if (edad >= 50) {
                        return "Master 50+"
                    } else if (edad >= 40) {
                        return "Master 40-49"
                    } else {
                        return "Libre"
                    }
                },
                buscar: "fechaNacimiento",
            },
            {
                title: "Correo",
                dataIndex: "correo",
                key: "correo",
                sorter: (a, b) => {
                    if (a.correo < b.correo) {
                        return -1;
                    }
                    if (a.correo > b.correo) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "correo",
            },
            {
                title: "Equipo",
                dataIndex: "equipo",
                key: "equipo",
                sorter: (a, b) => {
                    if (a.equipo < b.equipo) {
                        return -1;
                    }
                    if (a.equipo > b.equipo) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "equipo",
            },
            {
                title: "Carrera",
                dataIndex: "carreraNombre",
                key: "carreraNombre",
                sorter: (a, b) => {
                    if (a.carreraNombre < b.carreraNombre) {
                        return -1;
                    }
                    if (a.carreraNombre > b.carreraNombre) {
                        return 1;
                    }
                    return 0;
                },
            },
            {
                title: "Accion",
                dataIndex: "accion",
                key: "accion",
                render: (value) => (
                    <Space size="small">
                        {
                            <EditOutlined
                                onClick={() => this.editarCarrera(value._id)}
                                style={{ color: "blue" }}
                            />
                        }
                        {
                            <>
                                {value.estadoPago === 1 || value.estadoPago === 2 ? (
                                    <>
                                        {value.estadoPago === 2 && (<Tag color="blue">Pago</Tag>)}
                                        {round2Decimals(value.total - value.totalPagado) > 0 ?
                                            <Button size="small" onClick={() => this.registrarPago(value._id)}>
                                                Registrar Pago
                                            </Button>
                                            :
                                            <Button size="small" onClick={() => this.registrarDevolucion(value._id)}>
                                                Registrar Devolucion
                                            </Button>
                                        }
                                    </>
                                ) : (
                                    <Tag color="green">Pagado</Tag>
                                )}
                            </>
                        }
                        {value.estadoPago === 1 || value.estadoPago === 2 ?
                            <Tooltip title="Enviar correo de registro">
                                <MailOutlined
                                    onClick={() => this.mandarCorreoRegistro(value._id)}
                                    />
                            </Tooltip>
                            :
                            <Tooltip title="Enviar correo de pago realizado">
                                <MailOutlined
                                    onClick={() => this.mandarPagoRegistro(value._id)}
                                    style={{ color: "green" }}
                                />
                            </Tooltip>
                        }
                    </Space>
                ),
                width: "20%",
            },
        ];
        const columnsCelular = [
            {
                title: "Folio",
                dataIndex: "folio",
                key: "folio",
                sorter: (a, b) => {
                    if (a.folio < b.folio) {
                        return -1;
                    }
                    if (a.folio > b.folio) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "folio",
                width: "20%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                sorter: (a, b) => {
                    if (a.nombre < b.nombre) {
                        return -1;
                    }
                    if (a.nombre > b.nombre) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "nombre",
                width: "30%",
            },
            {
                title: "Accion",
                dataIndex: "accion",
                key: "accion",
                render: (value) => (
                    <Space size="small">
                        {
                            <EditOutlined
                                onClick={() => this.editarCarrera(value._id)}
                                style={{ color: "blue" }}
                            />
                        }
                        {
                            <>
                                {value.estadoPago === 1 || value.estadoPago === 2 ? (
                                    <>
                                        {value.estadoPago === 2 && (<Tag color="blue">Pago</Tag>)}
                                        {round2Decimals(value.total - value.totalPagado) > 0 ?
                                            <Button size="small" onClick={() => this.registrarPago(value._id)}>
                                                Registrar Pago
                                            </Button>
                                            :
                                            <Button size="small" onClick={() => this.registrarDevolucion(value._id)}>
                                                Registrar Devolucion
                                            </Button>
                                        }
                                    </>
                                ) : (
                                    <Tag color="green">Pagado</Tag>
                                )}
                            </>
                        }
                    </Space>
                ),
                width: "50%",
            },
        ];
        return (
            <>
                <PageHeaderItem
                    title="Registros"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <Space style={{ width: "100%" }}>
                            {window.innerWidth > 1000 &&
                                <Segmented
                                    options={[
                                        {
                                            label: 'Todos',
                                            value: 1
                                        },
                                        {
                                            label: 'Pendiente',
                                            value: 2
                                        },
                                        {
                                            label: 'Pagado',
                                            value: 3
                                        }
                                    ]}
                                    value={this.state.segmented}
                                    onChange={this.onChangeSegmented.bind(this)}
                                />
                            }
                            <Select
                                placeholder="Año"
                                width={200}
                                value={this.state.ano}
                                style={{ minWidth: '100px' }}
                                onChange={this.onChangeAno.bind(this)}
                            >
                                {this.state.objetoAnos}
                            </Select>
                            <Button
                                size="small"
                                type="primary"
                                key="agregarRegistro"
                                onClick={this.agregarCarrera.bind(this)}
                            >
                                {window.innerWidth > 1000 ? "Agregar Registro" : 'Agregar'}
                            </Button>
                            <FileExcelOutlined onClick={this.descargarExcel.bind(this)} />
                        </Space>
                    }
                />
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasRegistros}
                    columns={window.innerWidth > 1000 ? columns : columnsCelular}
                />
                <AgregarRegistro
                    visible={this.state.modalAgregarRegistro}
                    cerrarModalAgregarRegistro={this.cerrarModalAgregarRegistro.bind(this)}
                />
                <EditarRegistro
                    visible={this.state.modalEditarRegistro}
                    id={this.state.modalEditarRegistroId}
                    cerrarModalEditarRegistro={this.cerrarModalEditarRegistro.bind(this)}
                />
                <EditarRegistro
                    visible={this.state.modalEditarRegistro}
                    id={this.state.modalEditarRegistroId}
                    cerrarModalEditarRegistro={this.cerrarModalEditarRegistro.bind(this)}
                />
                <RegistrarPago
                    visible={this.state.modalRegistrarPago}
                    id={this.state.modalRegistrarPagoId}
                    cerrarModalRegistrarPago={this.cerrarModalRegistrarPago.bind(this)}
                />
                <RegistrarDevolucion
                    visible={this.state.modalRegistrarDevolucion}
                    id={this.state.modalRegistrarDevolucionId}
                    cerrarModalRegistrarDevolucion={this.cerrarModalRegistrarDevolucion.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
    };
};

export default connect(mapStateToProps)(Registros);